module.exports = __webpack_public_path__ + "img/dr-bc-body-1.e7603bc7.png";